import styled from "styled-components/native";
import { AnimatedDropdownProps } from "./types";
import { Theme } from "../../../../../theming/types";

type ContainerProps = Pick<
  AnimatedDropdownProps,
  "top" | "left" | "width" | "isTop"
>;

export const Container = styled.View<ContainerProps>`
  display: flex;
  left: ${({ left }: ContainerProps) => left}px;
  padding-top: 8px;
  position: ${({ isTop }: ContainerProps) => (isTop ? "fixed" : "absolute")};
  top: ${({ top }: ContainerProps) => top}px;
  width: ${({ width }: ContainerProps) => width}px;
`;

export const ContentContainer = styled.View`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 999;
`;

export const Dropdown = styled.View<{
  theme: Theme;
  children?: React.ReactNode;
}>`
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.colorTokens.background.surface};
  border-color: ${({ theme }: { theme: Theme }) =>
    theme.colorTokens.border.default};
  border-radius: 4px;
  border-width: 1px;
`;

export const ListItem = styled.View<{ children?: React.ReactNode }>`
  display: flex;
`;
